// extracted by mini-css-extract-plugin
export default {"wrapperPadding":"Information_wrapperPadding__fRnsT"};